import { GET_BLOCK_FEEDBACK_LIST, GET_CLUSTER_FEEDBACK_LIST, GET_DISTRICT_FEEDBACK_LIST, GET_FEEDBACK_COUNTS, GET_FEEDBACK_LIST, GET_FEEDBACK_REPLIES_LIST, GET_SCHOOL_FEEDBACK_LIST, RESET_FEEDBACK_REPLIES_DATA } from "../actions/FeedbackActions";

const initialState = {// initialize states
  List: [],
  feedBackReplies: [],
  feedbackCounts: [],
  DistrictList: [],
  BlockList: [],
  ClusterList: [],
  SchoolList: []
};

const FeedbackReducer = function (state = initialState, action) {
  switch (action.type) {
    case GET_FEEDBACK_LIST: {
      return { ...state, List: action.payload.data ? action.payload.data : [] };
    }
    case GET_FEEDBACK_REPLIES_LIST: {
      return { ...state, feedBackReplies: action.payload.data ? (action.payload.data.length == 0 ? [{ is_data_present: "Data Not Found" }] : action.payload.data) : [] };
    }
    case GET_FEEDBACK_COUNTS: {
      return { ...state, feedbackCounts: action.payload.data ? action.payload.data : [] };
    }
    case GET_DISTRICT_FEEDBACK_LIST: {
      return { ...state, DistrictList: action.payload.data ? action.payload.data : [] };
    }
    case GET_BLOCK_FEEDBACK_LIST: {
      return { ...state, BlockList: action.payload.data ? action.payload.data : [] };
    }
    case GET_CLUSTER_FEEDBACK_LIST: {
      return { ...state, ClusterList: action.payload.data ? action.payload.data : [] };
    }
    case GET_SCHOOL_FEEDBACK_LIST: {
      return { ...state, SchoolList: action.payload.data ? action.payload.data : [] };
    }
    case RESET_FEEDBACK_REPLIES_DATA: {
      return { ...state, feedBackReplies: [] };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default FeedbackReducer;
